// extracted by mini-css-extract-plugin
export default {"Submenu":"ContentLayout_Submenu__cmXRe","ActionMenu":"ContentLayout_ActionMenu__Taxuk","MainContentWrapper":"ContentLayout_MainContentWrapper__SE0xO"};